import type { GridSettings } from "../native/grid";
import type { Camera } from "../native/geometry";
export class NativeGrid {
  readonly settings: GridSettings = {
    mode: 0,
    step: 30,
    edges: true,
    vertices: false,
  };
  constructor(
    private changed: () => void,
    clearSelection: () => void,
  ) {
    const button = document.getElementById("native-grid-toggle")!;
    const panel = document.getElementById("native-grid-settings")!;
    const input = document.getElementById(
      "native-grid-size",
    ) as HTMLInputElement;
    const slider = document.getElementById(
      "native-grid-range",
    ) as HTMLInputElement;
    const close = () => {
      slider.hidden = true;
      input.readOnly = true;
      input.value = String(this.settings.step);
    };
    button.onclick = () => {
      this.settings.mode = (this.settings.mode + 1) % 3;
      panel.hidden = this.settings.mode !== 1;
      button.setAttribute("aria-pressed", String(!!this.settings.mode));
      button.title = [
        "Показать сетку",
        "Скрыть настройки сетки",
        "Выключить сетку",
      ][this.settings.mode]!;
      button.setAttribute("aria-label", button.title);
      close();
      if (this.settings.mode !== 2) clearSelection();
      changed();
    };
    for (const key of ["edges", "vertices"] as const) {
      document.getElementById("native-grid-" + key)!.onclick = () => {
        this.settings[key] = !this.settings[key];
        if (this.settings[key])
          this.settings[key === "edges" ? "vertices" : "edges"] = false;
        for (const k of ["edges", "vertices"] as const)
          document
            .getElementById("native-grid-" + k)!
            .setAttribute("aria-pressed", String(this.settings[k]));
        changed();
      };
    }
    input.onclick = () => {
      if (!input.readOnly) return;
      if (slider.hidden) {
        slider.value = String(this.settings.step);
        slider.hidden = false;
        input.blur();
      } else if (
        !matchMedia(
          "(max-width:760px), (pointer:coarse) and (max-width:1024px)",
        ).matches
      ) {
        slider.hidden = true;
        input.readOnly = false;
        input.focus();
        input.select();
      }
    };
    input.oninput = () => {
      const value = parseInt(input.value, 10);
      if (value >= 10 && value <= 200) {
        this.settings.step = value;
        slider.value = String(value);
        changed();
      }
    };
    input.onblur = () => {
      input.readOnly = true;
      input.value = String(this.settings.step);
    };
    slider.oninput = () => {
      input.value = slider.value;
      input.dispatchEvent(new Event("input"));
    };
    document.addEventListener("pointerdown", (event) => {
      if (!(event.target as HTMLElement).closest("#native-grid-controls"))
        close();
    });
    document
      .getElementById("native-grid-controls")!
      .addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          event.stopPropagation();
          close();
          button.focus();
        }
      });
  }
  draw(
    ctx: CanvasRenderingContext2D,
    camera: Camera,
    size: { width: number; height: number },
    width: number,
    height: number,
  ) {
    if (!this.settings.mode) return;
    const step = this.settings.step,
      z = camera.zoom;
    ctx.save();
    ctx.beginPath();
    ctx.rect(camera.x, camera.y, size.width * z, size.height * z);
    ctx.clip();
    // Two-tone hairlines remain visible across both dark and light artwork.
    ctx.strokeStyle = "rgba(255,255,255,.38)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    const lines = (
      extent: number,
      offset: number,
      screen: number,
      vertical: boolean,
    ) => {
      const min = Math.max(0, -offset / z),
        max = Math.min(extent, (screen - offset) / z),
        origin = extent / 2;
      for (
        let value = origin + Math.ceil((min - origin) / step) * step;
        value <= max;
        value += step
      ) {
        const v = offset + value * z;
        if (vertical) {
          ctx.moveTo(v, camera.y);
          ctx.lineTo(v, camera.y + size.height * z);
        } else {
          ctx.moveTo(camera.x, v);
          ctx.lineTo(camera.x + size.width * z, v);
        }
      }
    };
    lines(size.width, camera.x, width, true);
    lines(size.height, camera.y, height, false);
    ctx.stroke();
    ctx.strokeStyle = "rgba(36,51,72,.32)";
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.restore();
  }
}
